import React, { useState, useRef, useEffect } from "react";
import styles from "./servicios.module.css";
import { Link } from "react-router-dom";
import { FaFilter } from "react-icons/fa";
import DomoticNavbar from "../Components/Navbar";


/* Importación de imágenes */
import ctrl_ilu from "./img/ctril_iluminacion.png";
import ctrl_seg from "./img/ctrl_seg.png";
import ctrl_persi from "./img/ctrl_persi.png";
import ctrl_electrodomesticos from "./img/electrodomesticos.jpg";
import ctrl_acss from "./img/ctrl_accs.jpeg";
import ctrl_cerraduras from "./img/ctrl_cerraduras.png";
import cam_red from "./img/cam_red.png";
import cam_ptz from "./img/cam_ptz.png";
import cam_esp from "./img/cam_esp.png";
import cam_ia from "./img/cam_ia.png";
import cam_term from "./img/cam_term.png";
import color_vu from "./img/color_vu.png";
import acusense from "./img/acusense.png";
import darkfighter from "./img/darkfighter.png";
import thermal from "./img/thermal.png";
import intercom from "./img/intercom.png";
import access_control from "./img/access_control.png";
import SeccionesText from "./SeccionesText-productos"



const DomoticsServices = () => {
  const [activeCategory, setActiveCategory] = useState("todos");
  const [activeSubcategory, setActiveSubcategory] = useState("todas");
  const [brandsPanelOpen, setBrandsPanelOpen] = useState(false);
  const brandsPanelRef = useRef(null);


 // Cerrar panel al hacer clic fuera
 useEffect(() => {
  const handleClickOutside = (event) => {
    if (brandsPanelRef.current && !brandsPanelRef.current.contains(event.target)) {
      // Verifica si el clic no fue en el botón de toggle
      if (!event.target.closest(`.${styles.brandsToggleButton}`)) {
        setBrandsPanelOpen(false);
      }
    }
  };

  document.addEventListener("mousedown", handleClickOutside);
  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, []);







  // Datos completos organizados
  const servicesData = {
    domotica: {
      name: "Domótica y Automatización",
      subcategories: {
        residencial: {
          name: "Soluciones Residenciales",
          items: [
            {
              name: "Control de Iluminación",
              description: "Sistemas inteligentes para gestión automática de iluminación con programación horaria, detección de presencia y control remoto.",
              features: ["App móvil", "Compatibilidad con voz", "Escenas personalizadas", "Ahorro energético"],
              image: ctrl_ilu,
              whatsapp: "0992060337",
              brands: ["Lutron", "Fibaro", "Honeywell"]
            },
            {
              name: "Control de Cortinas y Persianas",
              description: "Automatización de cortinas y persianas con sensores de luz, control por horario o mediante dispositivos móviles.",
              features: ["Integración con clima", "Protección UV automática", "Modo privacidad", "Silencioso"],
              image: ctrl_persi,
              whatsapp: "0992060337",
              brands: ["Somfy", "Lutron", "Hunter Douglas"]
            },
            {
              name: "Electrodomésticos Inteligentes",
              description: "Control y monitoreo de electrodomésticos desde cualquier lugar. Programación de rutinas y ahorro energético.",
              features: ["Notificaciones", "Consumo en tiempo real", "Geofencing", "Compatibilidad multiplataforma"],
              image: ctrl_electrodomesticos,
              whatsapp: "0992060337",
              brands: ["Samsung SmartThings", "LG ThinQ", "Bosch Home Connect"]
            },
            {
              name: "Cerraduras Digitales",
              description: "Sistemas de acceso sin llaves mediante huella digital, código numérico, tarjeta RFID o control remoto.",
              features: ["Registro de acceso", "Temporizadores", "Bloqueo remoto", "Copia de llaves digital"],
              image: ctrl_cerraduras,
              whatsapp: "0992060337",
              brands: ["Yale", "Schlage", "August"]
            }
          ]
        },
        corporativo: {
          name: "Soluciones Corporativas",
          items: [
            {
              name: "Control de Accesos",
              description: "Sistemas integrados para gestión de accesos en edificios corporativos con múltiples niveles de seguridad.",
              features: ["Control por horarios", "Multiplataforma", "Reportes detallados", "Integración con RRHH"],
              image: ctrl_acss,
              whatsapp: "0992060337",
              brands: ["HID Global", "Lenel", "Suprema"]
            },
            {
              name: "Automatización de Espacios",
              description: "Control centralizado de iluminación, climatización y multimedia en salas de reuniones y áreas comunes.",
              features: ["Paneles táctiles", "Control por voz", "Escenas preconfiguradas", "Monitoreo energético"],
              image: ctrl_seg,
              whatsapp: "0992060337",
              brands: ["Crestron", "AMX", "Control4"]
            }
          ]
        }
      },
      brands: ["Lutron", "Fibaro", "Control4", "Crestron", "Honeywell", "Somfy"]
    },
    seguridad: {
      name: "Seguridad Electrónica",
      subcategories: {
        videoVigilancia: {
          name: "Video Vigilancia",
          items: [
            {
              name: "ColorVu - Visión Color 24/7",
              description: "Cámaras con tecnología avanzada para video color durante todo el día, incluso en condiciones de baja luz.",
              features: ["Imágenes Full Color", "Resolución 4K", "Lente varifocal", "Audio bidireccional"],
              image: color_vu,
              whatsapp: "0992060337",
              brands: ["Hikvision", "Dahua", "Axis"]
            },
            {
              name: "AcuSense - Detección Inteligente",
              description: "Tecnología de aprendizaje profundo para diferenciar personas, vehículos y objetos con reducción de falsas alarmas.",
              features: ["Análisis de comportamiento", "Alarmas configurables", "Búsqueda inteligente", "Integración VMS"],
              image: acusense,
              whatsapp: "0992060337",
              brands: ["Hikvision", "Dahua"]
            },
            {
              name: "DarkFighter - Baja Iluminación",
              description: "Cámaras especializadas para ambientes con poca luz, manteniendo claridad y detalle en la imagen.",
              features: ["Sensibilidad extrema", "Reducción de ruido", "Infrarrojo inteligente", "WDR verdadero"],
              image: darkfighter,
              whatsapp: "0992060337",
              brands: ["Hikvision", "Axis"]
            },
            {
              name: "Cámaras Térmicas",
              description: "Tecnología termográfica para detección en condiciones climáticas adversas y medición de temperatura.",
              features: ["Detección sin luz", "Alarma por temperatura", "Análisis térmico", "Resistencia extrema"],
              image: thermal,
              whatsapp: "0992060337",
              brands: ["Flir", "Hikvision", "Dahua"]
            }
          ]
        },
        controlAccesos: {
          name: "Control de Accesos",
          items: [
            {
              name: "Sistemas Biométricos",
              description: "Solución completa para control de accesos mediante reconocimiento facial, huella dactilar o iris.",
              features: ["Anti-spoofing", "Capacidad 50,000 usuarios", "Detección de mascarillas", "Interfaz web"],
              image: access_control,
              whatsapp: "0992060337",
              brands: ["ZKTeco", "Suprema", "Hikvision"]
            },
            {
              name: "Intercomunicadores IP",
              description: "Sistemas de video porteros con pantalla táctil, control remoto desde móvil y apertura digital.",
              features: ["Video HD", "Nube opcional", "Multi inquilino", "Integración con alarmas"],
              image: intercom,
              whatsapp: "0992060337",
              brands: ["2N", "Comelit", "Hikvision"]
            }
          ]
        },
        monitoreo: {
          name: "Centros de Monitoreo",
          items: [
            {
              name: "Video Wall Profesional",
              description: "Solución completa para visualización en salas de control con decodificadores y software especializado.",
              features: ["Hasta 64 pantallas", "Control táctil", "Layouts personalizables", "Alta disponibilidad"],
              image: cam_ptz,
              whatsapp: "0992060337",
              brands: ["Hikvision", "Barco", "LG"]
            },
            {
              name: "Software VMS Avanzado",
              description: "Plataforma de gestión de video con analítica inteligente, business intelligence y control de múltiples sitios.",
              features: ["Mapa interactivo", "Búsqueda inteligente", "Integración POS", "Soporte multi-cámara"],
              image: cam_ia,
              whatsapp: "0992060337",
              brands: ["Milestone", "Genetec", "Hikvision"]
            },
            {
              name: "Video Porteros IP y Análogos",
              description: "Intercomunicadores para viviendas y oficinas con audio y video, control remoto de apertura.",
              features: ["Video HD", "Conectividad móvil", "Interfaz táctil", "Grabación de eventos"],
              image: intercom,
              whatsapp: "0992060337",
              brands: ["Hikvision", "ZKTeco", "Intelbras"]
            },
            {
              name: "Sistemas Condominiales",
              description: "Solución de intercomunicación para edificios de múltiples unidades, con control centralizado.",
              features: ["Llamadas internas", "Control remoto", "Conectividad LAN/WAN", "Pantalla a color"],
              image: intercom,
              whatsapp: "0992060337",
              brands: ["LONBON", "Intelbras"]
            },
            {
              name: "Intercomunicadores de Ventanilla",
              description: "Sistemas de comunicación de doble vía usados en bancos o ventanillas de atención.",
              features: ["Micrófono y bocina integrados", "Cancelación de ruido", "Montaje sencillo", "Uso intensivo"],
              image: intercom,
              whatsapp: "0992060337",
              brands: ["LONBON"]
            },
            {
              name: "Cerraduras Digitales para Hoteles",
              description: "Cerraduras electrónicas con lector de tarjeta, ideales para uso intensivo en sector hotelero.",
              features: ["Gestión remota", "Compatibilidad PMS", "Diseño premium", "Instalación sencilla"],
              image: ctrl_cerraduras,
              whatsapp: "0992060337",
              brands: ["KAADAS", "ZKTeco"]
            },
            {
              name: "Cerraduras Inteligentes Residenciales",
              description: "Acceso por huella, tarjeta, PIN o aplicación móvil. Perfectas para hogares y oficinas.",
              features: ["Hasta 100 usuarios", "Conectividad Wi-Fi", "Alerta de intrusos", "Bloqueo automático"],
              image: ctrl_cerraduras,
              whatsapp: "0992060337",
              brands: ["KAADAS", "Intelbras"]
            },
            {
              name: "Barras Antipánico",
              description: "Dispositivos de apertura rápida en emergencias, usados en salidas de evacuación.",
              features: ["Fácil liberación", "Resistencia mecánica", "Normativas vigentes", "Montaje universal"],
              image: ctrl_seg,
              whatsapp: "0992060337",
              brands: ["Intelbras", "ZKTeco"]
            },
            {
              name: "Cierra Puertas",
              description: "Mecanismos para cierre automático de puertas, garantizando seguridad y eficiencia energética.",
              features: ["Velocidad ajustable", "Diseño compacto", "Uso interior/exterior", "Certificaciones UL"],
              image: ctrl_seg,
              whatsapp: "0992060337",
              brands: ["Intelbras", "ZKTeco"]
            },
            {
              name: "Reconocimiento Facial",
              description: "Identificación sin contacto basada en biometría facial, ideal para acceso seguro y eficiente.",
              features: ["Detección de mascarilla", "Alta velocidad", "Algoritmos avanzados", "Capacidad masiva"],
              image: access_control,
              whatsapp: "0992060337",
              brands: ["ZKTeco", "Hikvision"]
            },
            {
              name: "Terminales Multibiométricas",
              description: "Equipos que permiten múltiples métodos de verificación como huella, tarjeta o código.",
              features: ["Multi-método", "Alta precisión", "Pantalla táctil", "Interfaz intuitiva"],
              image: access_control,
              whatsapp: "0992060337",
              brands: ["ZKTeco", "Anson", "Hikvision"]
            },
            {
              name: "Torniquetes Inteligentes",
              description: "Control físico de paso mediante torniquetes batientes, de trípode o verticales, integrables con biometría.",
              features: ["Integración con lectores", "Alta seguridad", "Diseño robusto", "Flujo controlado"],
              image: access_control,
              whatsapp: "0992060337",
              brands: ["ZKTeco", "Anson"]
            },
            {
              name: "Terminales para Visitantes",
              description: "Dispositivos de control para ingreso temporal de personas no registradas, con autorización remota.",
              features: ["Registro temporal", "Fotografía y firma", "Gestión por horarios", "Notificaciones automáticas"],
              image: access_control,
              whatsapp: "0992060337",
              brands: ["Hikvision", "ZKTeco"]
            },
            {
              name: "Paneles de Control de Accesos",
              description: "Controladores para gestionar múltiples puertas desde una sola plataforma.",
              features: ["Hasta 8 puertas", "Alarmas configurables", "Integración software", "Gestión centralizada"],
              image: access_control,
              whatsapp: "0992060337",
              brands: ["Anson", "ZKTeco", "Hikvision"]
            },
            {
              name: "Gestión por Categorías y Horarios",
              description: "Software para asignar accesos diferenciados por niveles, cargos, horarios o días.",
              features: ["Interfaz web", "Exportación de reportes", "Alertas configurables", "Multiusuario"],
              image: access_control,
              whatsapp: "0992060337",
              brands: ["Anson", "ZKTeco"]
            },
            {
              name: "Generación de Alarmas",
              description: "Notificación automática ante intentos de acceso no autorizados o fallos en la autenticación.",
              features: ["Alertas visuales y sonoras", "Registro de eventos", "Integración con cámaras", "Soporte técnico"],
              image: access_control,
              whatsapp: "0992060337",
              brands: ["ZKTeco", "Hikvision"]
            },
            {
              name: "Arcos de Detección de Metales",
              description: "Equipos de seguridad que detectan objetos metálicos, con opción de zonas múltiples y termografía.",
              features: ["Termografía opcional", "Sensores precisos", "Configuración por zonas", "Alta sensibilidad"],
              image: cam_term,
              whatsapp: "0992060337",
              brands: ["ZKTeco", "Anson"]
            },
            {
              name: "Lectores RFID y Accesorios",
              description: "Lectoras de credenciales por radiofrecuencia, compatibles con tarjetas, tags o llaveros.",
              features: ["Gran alcance", "Alta velocidad", "Multi formato", "Integración sencilla"],
              image: ctrl_acss,
              whatsapp: "0992060337",
              brands: ["ZKTeco", "Anson", "Hikvision"]
            },
            {
              name: "TV Wall",
              description: "Sistemas modulares de visualización para centros de monitoreo, con soporte para múltiples fuentes de video.",
              features: ["Pantallas sincronizadas", "Configuración flexible", "Alta resolución", "Escalabilidad"],
              image: cam_ptz,
              whatsapp: "0992060337",
              brands: ["Hikvision", "Hanwha", "ZKTeco"]
            },
            {
              name: "Decodificadores de Video",
              description: "Dispositivos para procesamiento y transmisión de video desde múltiples cámaras a pantallas de control.",
              features: ["Compatible con cámaras IP", "Transmisión estable", "Soporte multi-canal", "Integración con VMS"],
              image: cam_red,
              whatsapp: "0992060337",
              brands: ["Hikvision", "Hanwha", "Axis"]
            },
            {
              name: "Joystick para Cámaras PTZ",
              description: "Controladores físicos para operar cámaras motorizadas PTZ con precisión y rapidez.",
              features: ["Control en tiempo real", "Protocolos múltiples", "Ergonómico", "Interfaz intuitiva"],
              image: cam_esp,
              whatsapp: "0992060337",
              brands: ["Hikvision", "Hanwha", "ZKTeco"]
            },
            {
              name: "Licenciamiento Analítica de Video",
              description: "Activación de funciones de analítica avanzada como reconocimiento facial, conteo y búsqueda inteligente.",
              features: ["Análisis en tiempo real", "Fácil escalabilidad", "Reducción de falsos positivos", "Compatible con VMS"],
              image: cam_ia,
              whatsapp: "0992060337",
              brands: ["Hikvision", "Hanwha", "ZKTeco"]
            }
            
          ]
        }
      },
      brands: ["Hikvision", "Dahua", "Axis", "Hanwha", "ZKTeco", "Flir"]
    }
  };

  // Función para obtener los servicios a mostrar
  const getServicesToShow = () => {
    if (activeCategory === "todos") {
      return Object.values(servicesData).flatMap(category => 
        Object.values(category.subcategories).flatMap(subcat => subcat.items)
      );
    }
    
    if (activeSubcategory === "todas") {
      return Object.values(servicesData[activeCategory].subcategories)
        .flatMap(subcat => subcat.items);
    }
    
    return servicesData[activeCategory].subcategories[activeSubcategory].items;
  };

  // Obtener subcategorías activas
  const getActiveSubcategories = () => {
    if (activeCategory === "todos") return [];
    return Object.entries(servicesData[activeCategory].subcategories);
  };

  return (
    <>
      <DomoticNavbar />
       {/* Botón para desplegar panel de marcas (fixed) */}
     

      {/* Panel lateral de marcas */}
      <div 
        ref={brandsPanelRef}
        className={`${styles.brandsPanel} ${brandsPanelOpen ? styles.open : ''}`}
      >
        <div className={styles.brandsPanelContent}>
          <h3>Marcas por Categoría</h3>
          
          <div className={styles.brandCategory}>
            <h4>Domótica y Automatización</h4>
            <div className={styles.brandList}>
              {servicesData.domotica.brands.map((brand, index) => (
                <div key={`domotica-${index}`} className={styles.brandItem}>
                  {brand}
                </div>
              ))}
            </div>
          </div>
          
          <div className={styles.brandCategory}>
            <h4>Seguridad Electrónica</h4>
            <div className={styles.brandList}>
              {servicesData.seguridad.brands.map((brand, index) => (
                <div key={`seguridad-${index}`} className={styles.brandItem}>
                  {brand}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      
      {/* Hero Section */}
      <div className={styles.hero}>
        <h1>Soluciones Inteligentes</h1>
        <p>Con nosotros tendrá calidad y eficiencia para su Empresa u Hogar</p>
      </div>

      {/* Filtros principales */}
      <div className={styles.filterContainer}>
        <button 
          className={`${styles.filterButton} ${activeCategory === "todos" ? styles.active : ""}`}
          onClick={() => {
            setActiveCategory("todos");
            setActiveSubcategory("todas");
          }}
        >
          Todos los productos y servicios
        </button>
        
        {Object.entries(servicesData).map(([key, category]) => (
          <button
            key={key}
            className={`${styles.filterButton} ${activeCategory === key ? styles.active : ""}`}
            onClick={() => {
              setActiveCategory(key);
              setActiveSubcategory("todas");
            }}
          >
            {category.name}
          </button>
        ))}
      </div>

      {/* Filtros de subcategorías */}
      {getActiveSubcategories().length > 0 && (
        <div className={styles.subcategoryFilter}>
          <button
            className={`${styles.subcategoryButton} ${activeSubcategory === "todas" ? styles.active : ""}`}
            onClick={() => setActiveSubcategory("todas")}
          >
            Todas las subcategorías
          </button>
          
          {getActiveSubcategories().map(([key, subcategory]) => (
            <button
              key={key}
              className={`${styles.subcategoryButton} ${activeSubcategory === key ? styles.active : ""}`}
              onClick={() => setActiveSubcategory(key)}
            >
              {subcategory.name}
            </button>
          ))}
        </div>
      )}

     

      {/* Listado de servicios */}
      <section className={styles.servicesSection}>
        <div className={styles.servicesGrid}>
          {getServicesToShow().map((item, i) => (
            <div key={`${item.name}-${i}`} className={styles.serviceCard}>
              <div className={styles.cardImage}>
                <img src={item.image} alt={item.name} />
                <div className={styles.cardOverlay}>
                  <a
                    href={`https://wa.me/${item.whatsapp}?text=Hola, estoy interesado en ${item.name}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.whatsappButton}
                  >
                    <i className="fab fa-whatsapp"></i> Consultar
                  </a>
                </div>
              </div>
              
              <div className={styles.cardContent}>
                <h3>{item.name}</h3>
                <p>{item.description}</p>
                
                <div className={styles.features}>
                  <h4>Características principales:</h4>
                  <ul>
                    {item.features.map((feature, j) => (
                      <li key={j}>{feature}</li>
                    ))}
                  </ul>
                </div>
                
                <div className={styles.brands}>
                  <h4>Marcas disponibles:</h4>
                  <div className={styles.brandTags}>
                    {item.brands.map((brand, k) => (
                      <span key={k} className={styles.brandTag}>{brand}</span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
<SeccionesText/>

      {/* Sección de asesoramiento */}
      <div className={styles.ctaSection}>
        <h2>¿Necesitas una solución personalizada?</h2>
        <p>Nuestros expertos pueden diseñar un sistema a medida para tus necesidades</p>
        <a 
          href="https://wa.me/0992060337?text=Hola, necesito asesoramiento para una solución personalizada" 
          className={styles.ctaButton}
          target="_blank"
          rel="noopener noreferrer"
        >
          Contactar a un especialista
        </a>
      </div>
    </>
  );
};

export default DomoticsServices;